import { render, staticRenderFns } from "./newcourse.vue?vue&type=template&id=0bb70a81&scoped=true"
import script from "./newcourse.vue?vue&type=script&lang=js"
export * from "./newcourse.vue?vue&type=script&lang=js"
import style0 from "./newcourse.vue?vue&type=style&index=0&id=0bb70a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb70a81",
  null
  
)

export default component.exports